// Toast.js
import React, { useEffect } from "react";

const Toast = ({ message, duration = 3000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed top-5 right-5 bg-green-500 text-white px-5 py-3 rounded shadow-md z-[9999] animate-toast">
      {message}
    </div>
  );
};

export default Toast;
